/* eslint-disable no-console */
import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectContact = (state) => state.getContact || initialState

const makeSelectContact = () => createSelector(
  selectContact,
  (state) => state
)

export {
  selectContact,
  makeSelectContact
}
